<script setup>
import { Actions, EventManager } from "@events";
import VideoCallButton from "@/components/Common/VideoCallButton.vue";

import { useVideoCallState } from "@/stores/videoCallState";
import { computed } from "vue";

const props = defineProps({
  rtcId: {
    type: String,
    required: true,
  },
});

const actionEmitter = EventManager.getActionEmitter(props.rtcId);
const state = useVideoCallState(props.rtcId);

function toggleMute() {
  actionEmitter.emit(
    state.remoteAudioMuted ? Actions.UnmuteRemoteAudio : Actions.MuteRemoteAudio
  );
}

const iconClass = computed(() => {
  if (state.remoteAudioMuted) {
    return "mdi-ear-hearing-off";
  }
  return "mdi-ear-hearing";
});
</script>
<template>
  <VideoCallButton
    :active="state.remoteAudioMuted"
    :icon="iconClass"
    @click="toggleMute"
    :disabled="state.disableVideoControls"
  ></VideoCallButton>
</template>

  